export default __webpack_public_path__ + "static/media/login_email.eb4a3676.svg";